export const version = "1.0.2-daily-20250725-1";
export const channel = "daily";
export const gitcommit = "66628de66";
